import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateBuildingFailure,
  CreateBuildingRequest,
  CreateBuildingSuccess,
  FetchBuildingFailure,
  FetchBuildingRequest,
  FetchBuildingSuccess,
  UpdateBuildingFailure,
  UpdateBuildingRequest,
  UpdateBuildingSuccess,
} from './digitization.actions'
import { DigitizationService } from './digitization.service'
import * as DigitizationTypes from './digitization.types'

@Injectable()
export class DigitizationEffects {
  constructor(
    private actions: Actions,
    private digitizationService: DigitizationService,
    private router: Router,
  ) {}

  FetchBuilding$ = createEffect(() =>
    this.actions.pipe(
      ofType(DigitizationTypes.FETCH_BUILDING_REQUEST),
      switchMap((action: FetchBuildingRequest) => {
        return this.digitizationService.fetchBuilding(action.id).pipe(
          map((result) => {
            return new FetchBuildingSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchBuildingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateBuilding$ = createEffect(() =>
    this.actions.pipe(
      ofType(DigitizationTypes.UPDATE_BUILDING_REQUEST),
      switchMap((action: UpdateBuildingRequest) => {
        return this.digitizationService
          .updateBuilding(action.buildingId, action.payload)
          .pipe(
            map((result) => {
              return new UpdateBuildingSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new UpdateBuildingFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CreateBuilding$ = createEffect(() =>
    this.actions.pipe(
      ofType(DigitizationTypes.CREATE_BUILDING_REQUEST),
      switchMap((action: CreateBuildingRequest) => {
        return this.digitizationService.createBuilding(action.payload).pipe(
          map((result) => {
            return new CreateBuildingSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new CreateBuildingFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
